export default __webpack_public_path__ + "public/icons/addIssueType.png?2f76e8eac806f0371771cc7dd55676e1";